import { render, staticRenderFns } from "./Lootbox.vue?vue&type=template&id=4c5c8313&"
import script from "./Lootbox.vue?vue&type=script&lang=js&"
export * from "./Lootbox.vue?vue&type=script&lang=js&"
import style0 from "./Lootbox.vue?vue&type=style&index=0&id=4c5c8313&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports